import styled from 'styled-components';

export const RoutesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 10px;
`;

export const RouteTile = styled.button`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 64px;
    padding: 12px 14px 12px 18px;
    border-radius: 10px;
    border: 2px solid ${({ theme }) => theme.colors.gray?.[200] || '#E5E7EB'};
    background: #fff;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 6px;
        top: 10px;
        bottom: 10px;
        width: 4px;
        border-radius: 3px;
        background: ${({ theme }) => theme.colors.indigo?.main || '#6366F1'};
    }

    &:hover {
        border-color: ${({ theme }) => theme.colors.indigo?.main || '#6366F1'};
        background: ${({ theme }) => theme.colors.indigo?.light || '#EEF2FF'};
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.colors.primary?.main || '#2563EB'};
        outline-offset: 2px;
    }
`;

export const RouteTileIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.indigo?.light || '#EEF2FF'};
    color: ${({ theme }) => theme.colors.indigo?.main || '#6366F1'};

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const RouteTileBody = styled.span`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
`;

export const RouteTileTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray?.[900] || '#111827'};
    line-height: 1.35;
`;

export const RouteTileMeta = styled.span`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.gray?.[500] || '#6B7280'};
    line-height: 1.4;
`;

export const RouteTileArrow = styled.span`
    flex-shrink: 0;
    font-size: 1.1rem;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.gray?.[400] || '#9CA3AF'};
    line-height: 1;
    transition: color 0.15s ease, transform 0.15s ease;

    ${RouteTile}:hover & {
        color: ${({ theme }) => theme.colors.indigo?.main || '#6366F1'};
        transform: translateX(2px);
    }
`;
